import * as React from 'react';

import {CalendarPenIcon} from 'shells/icon/svg/calendar-pen-icon';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

import {useGetCsmInfo} from '../../../sidebar/meet-your-csm/use-get-csm-info';

import {SupportStack} from './support-stack';

import styles from './support-section.module.css';

export function LargeTeamMessage() {
    let link = 'https://growth.nutshell.com/n/schedule-booking/4/D71aqb';

    const {csmInfo} = useGetCsmInfo();
    if (csmInfo) {
        link = csmInfo.calendlyLink;
    }

    return (
        <SupportStack
            title='Can we help?'
            body={
                <StackLegacy spacing={8}>
                    <Body size='small'>
                        Schedule a free Q&A session with our customer success strategists.
                    </Body>
                    <Link
                        size='small'
                        variant='button-secondary'
                        href={link}
                        newTab={true}
                        isFullWidth={true}
                    >
                        <div className='flex gap-8 align-center justify-center'>
                            <div className={styles.icon}>
                                <CalendarPenIcon size={13} alignCenter={true} />
                            </div>
                            <span>Schedule Q&amp;A session</span>
                        </div>
                    </Link>
                </StackLegacy>
            }
        />
    );
}
